import { Clock, MapPin, Mic } from "lucide-react";
import { KEYNOTE } from "../data/conferenceData";

export default function Keynote() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="keynote-page">
      <div
        className="shadow-card"
        style={{
          backgroundColor: "var(--surface)",
          borderRadius: "16px",
          overflow: "hidden",
          border: "1px solid var(--border)",
        }}
      >
        <div
          style={{
            width: "100%",
            aspectRatio: "5 / 4",
            backgroundColor: "var(--background)",
          }}
        >
          <img
            src={KEYNOTE.image}
            alt={KEYNOTE.name}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            data-testid="keynote-image"
          />
        </div>
        <div style={{ padding: "16px" }}>
          <div
            className="flex items-center"
            style={{ gap: "6px", marginBottom: "8px" }}
          >
            <Mic size={14} color="var(--primary)" />
            <span
              style={{
                fontSize: "11px",
                fontWeight: 800,
                letterSpacing: "1.5px",
                color: "var(--primary)",
                textTransform: "uppercase",
              }}
            >
              Keynote
            </span>
          </div>
          <h2
            style={{
              fontSize: "26px",
              fontWeight: 800,
              color: "var(--primary-dark)",
              lineHeight: "30px",
            }}
          >
            {KEYNOTE.name}
          </h2>
          <p
            style={{
              fontSize: "14px",
              fontWeight: 700,
              color: "var(--text-secondary)",
              marginTop: "4px",
            }}
          >
            {KEYNOTE.title}
          </p>

          <div
            className="flex flex-wrap"
            style={{
              marginTop: "12px",
              paddingTop: "12px",
              borderTop: "1px solid var(--border)",
              gap: "16px",
              fontSize: "13px",
              color: "var(--text-muted)",
              fontWeight: 600,
            }}
          >
            <span className="flex items-center" style={{ gap: "6px" }}>
              <Clock size={14} /> 8:30 - 9:15 AM
            </span>
            <span className="flex items-center" style={{ gap: "6px" }}>
              <MapPin size={14} /> Auditorium
            </span>
          </div>
        </div>
      </div>

      <p
        style={{
          fontSize: "14px",
          lineHeight: "22px",
          marginTop: "16px",
          color: "var(--text-muted)",
        }}
        data-testid="keynote-bio"
      >
        {KEYNOTE.bio}
      </p>
    </div>
  );
}
